import { useSnackbar } from "notistack";

const useNotifyHandler = () => {
  const { enqueueSnackbar } = useSnackbar();

  const alertNotify = (text, vertical, horizontal, typeLabel) => {
    try {
      enqueueSnackbar(text, {
        autoHideDuration: 3500,
        variant: typeLabel,
        anchorOrigin: {
          vertical: vertical,
          horizontal: horizontal,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  return { alertNotify };
};

export default useNotifyHandler;
